import { createAsyncThunk } from "@reduxjs/toolkit";
import { logout, setLoading, setInitialized } from "../slices/userSlice";
import { backendApi } from "../../common/backend-api/backend-api";

// Action type for resetting the entire Redux state
export const RESET_STATE = 'RESET_STATE';

// Create a thunk to handle logout and reset the entire Redux state
export const logoutThunk = createAsyncThunk(
    'user/logout',
    async (_, { dispatch }) => {
        try {
            // First, ensure loading state is explicitly set to false
            dispatch(setLoading(false));
            
            // Dispatch the logout action to clear user state
            await dispatch(logout());
            
            // Reset the Redux API query cache
            dispatch(backendApi.util.resetApiState());
            
            // Dispatch a global reset action that all reducers can listen to
            dispatch({ type: RESET_STATE });
            
            // After state reset, ensure the UserReducer is properly initialized
            // This is crucial for the auth flow to work correctly
            dispatch(setInitialized(true));
            dispatch(setLoading(false));
            
            // Return success to indicate the logout was completed
            return { success: true };
        } catch (error) {
            // Make sure loading is set to false even if there's an error
            dispatch(setLoading(false));
            dispatch(setInitialized(true));
            throw error;
        }
    }
);

